import { TagsStateType } from './types';

import { Pagination, TagsActionType } from 'enums';
import { TagsActionReturnType } from 'state/actions';

const initState: TagsStateType = {
  tags: [],
  search: '',
  page: Pagination.START_PAGE,
};

export const tagsReducer = (
  // eslint-disable-next-line default-param-last
  state: TagsStateType = initState,
  action: TagsActionReturnType,
): TagsStateType => {
  switch (action.type) {
    case TagsActionType.SET_TAGS:
      return { ...state, tags: action.tags };
    case TagsActionType.SET_TAGS_AFTER_SCROLL:
      return { ...state, tags: [...state.tags, ...action.tags] };
    case TagsActionType.SEARCH_TAGS:
      return { ...state, search: action.search };
    case TagsActionType.SET_TAGS_PAGINATION:
      return { ...state, count: action.pagination.count, page: action.pagination.page };
    default:
      return state;
  }
};
